/**
 *
 * ShareReportModal
 *
 */

import React, { useState } from 'react';
import {
  ModalContent,
  ModalHeader,
  Button,
  Dropdown,
  Conditional,
  Space,
  Text,
  InputField,
  Cross,
  Modal,
  RadioButton,
  Form,
} from '@cashfree-intl/coherent';
import PropTypes from 'prop-types';
import { copyToClipboard } from 'utils/common';
import { StyledInputField } from 'components/FormGenerator/styled';
import FormikComponent from 'components/Formik';
import {
  ACCESS_OPTIONS,
  CHANNEL_OPTIONS,
  EMAIL,
  EXPIRATION_OPTIONS,
  PHONE,
  RESTRICTED,
} from './constants';
import validationSchema from './validation';
import { StyledButton, StyledButtonDanger } from './styled';

function ShareReportModal({ onClose, onConfirm, link, isLoading }) {
  const accessConfig = {
    name: ACCESS_OPTIONS[0].value,
  };
  const [channelConfig, setChannelConfig] = useState({
    name: CHANNEL_OPTIONS[0].value,
  });
  const [selectedExpiry, setSelectedExpiry] = useState({
    value: '15m',
  });
  // const [modalState, setModalState] = useState(true);

  const handleChannelConfig = (e, { value }) => {
    setChannelConfig({ name: value });
  };

  const handleExpiryChange = (e, data) => {
    setSelectedExpiry({ value: data.value });
  };

  const handleCancel = () => {
    onClose();
  };

  const submitForm = values => {
    const json = {
      access_type: accessConfig.name,
    };
    if (accessConfig.name === RESTRICTED && channelConfig.name === EMAIL) {
      json.auth_channel = channelConfig.name;
      json.channel_value = values.channel_email;
    } else if (
      accessConfig.name === RESTRICTED &&
      channelConfig.name === PHONE
    ) {
      json.auth_channel = channelConfig.name;
      json.channel_value = values.channel_phone;
    }
    json.expiry = selectedExpiry.value;

    onConfirm(json);
  };

  return (
    <Modal open className="common-modal-wrapper webhook-modal">
      <ModalHeader>
        Share Report <Cross onClick={handleCancel} />
      </ModalHeader>
      <Conditional if={link !== ''}>
        <ModalContent>
          <div className="modal-content">
            <Space justifyContent="space-between">
              <Space gap={0}>
                <StyledInputField
                  name="shareable_link"
                  disabled
                  value={link}
                  width="410px"
                  maxWidth="500px"
                />
                <Button
                  link
                  onClick={() => {
                    copyToClipboard(link)();
                  }}
                >
                  Copy
                </Button>
              </Space>
            </Space>
            <Text variant="b14" color="bodyLight" className="mt-2">
              Copy the above link and share it to users to access this report.
            </Text>
          </div>
        </ModalContent>
      </Conditional>
      <Conditional if={link === ''}>
        <ModalContent>
          <div className="modal-content">
            <FormikComponent
              initialValues={{
                channel_email: '',
                channel_phone: '',
              }}
              validationSchema={validationSchema}
              onSubmit={submitForm}
            >
              {({
                values = {
                  channel_email: '',
                  channel_phone: '',
                },
                handleFieldBlur,
                handleFieldChange,
                handleSubmit,
                errors,
                touched,
              }) => (
                <Form autoComplete="off" onSubmit={handleSubmit}>
                  <Conditional if={accessConfig.name === RESTRICTED}>
                    <Text variant="h16" className="mb-1">
                      How do you want to send this report?
                    </Text>
                    <Space justifyContent="space-between">
                      <Space gap={8}>
                        {CHANNEL_OPTIONS.map(option => (
                          <RadioButton
                            key={option.value}
                            name={option.value}
                            onChange={handleChannelConfig}
                            checked={channelConfig.name === option.value}
                            {...option}
                          />
                        ))}
                      </Space>
                    </Space>
                    <br />
                    <Conditional if={channelConfig.name === 'EMAIL'}>
                      <InputField
                        fluid
                        id="channel_email"
                        name="channel_email"
                        value={values.channel_email}
                        errors={errors}
                        touched={touched}
                        placeholder="help@email.com"
                        onChange={handleFieldChange}
                        onBlur={handleFieldBlur}
                      />
                    </Conditional>
                    <Conditional if={channelConfig.name === 'PHONE'}>
                      <InputField
                        fluid
                        id="channel_phone"
                        name="channel_phone"
                        value={values.channel_phone}
                        errors={errors}
                        touched={touched}
                        placeholder="9999999999"
                        onChange={handleFieldChange}
                        onBlur={handleFieldBlur}
                      />
                    </Conditional>
                  </Conditional>
                  <br />
                  <Text variant="h16" className="mb-1">
                    Validity
                  </Text>
                  <Dropdown
                    placeholder="Select Expiration"
                    options={EXPIRATION_OPTIONS}
                    selection
                    icon="chevron down"
                    onChange={handleExpiryChange}
                    defaultValue={selectedExpiry.value}
                  />
                  <Text variant="b12" color="bodyLight" className="mr-top-n16">
                    This report will be accessible for the next{' '}
                    {
                      EXPIRATION_OPTIONS.find(
                        obj => obj.value === selectedExpiry.value,
                      )?.text
                    }
                  </Text>
                  <br />
                  <Space gap={2} direction="row" justifyContent="space-between">
                    <StyledButtonDanger variant="link" onClick={handleCancel}>
                      Cancel
                    </StyledButtonDanger>
                    <StyledButton
                      primary
                      loading={isLoading === true}
                      type="submit"
                    >
                      Share
                    </StyledButton>
                  </Space>
                </Form>
              )}
            </FormikComponent>
          </div>
        </ModalContent>
      </Conditional>
    </Modal>
  );
}

ShareReportModal.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  link: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ShareReportModal;
